export const SUCCESS_EMAIL_CONFIRMED_MESSAGE = 'Your email was confirmed successfully. You can now login below using your credentials.';
